import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from '../../models/RootState';
import {
  fetchBalance,
  loginSuccess,
  otpLoginFailed,
  otpLoginSuccess,
  requestEnd,
  requestStart,
} from '../../store';
import SVLS_API from '../../api-services/svls-api';

const useOtpLogin = (modalCloseHandler: Function, redirectUrl?: string) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loggedIn = useSelector((state: RootState) => state.auth.loggedIn);

  const otpLogin = async () => {
    let urlParams = new URLSearchParams(window.location.search);
    dispatch(requestStart());
    try {
      if (loggedIn) {
        dispatch(otpLoginFailed('User already is Logged In.'));
        return;
      }

      const response = await SVLS_API.post('account/v2/otp-login', {
        otp: urlParams.get('otp'),
      });

      dispatch(requestEnd());

      getSapToken(response.data);
      let claim = response.data.split('.')[1];
      let userName = JSON.parse(window.atob(claim)).owner;
      sessionStorage.setItem('username', userName);
      sessionStorage.setItem('jwt_token', response.data);
      localStorage.removeItem(`multiMarket_${userName?.toLowerCase()}`);

      dispatch(loginSuccess(response.data));
      dispatch(otpLoginSuccess('Login Succeeded.'));

      sessionStorage.setItem('aid', JSON.parse(window.atob(claim)).aid);
      sessionStorage.setItem(
        'displayName',
        JSON.parse(window.atob(claim)).dispName
      );

      if (redirectUrl) {
        console.log(redirectUrl);
        history.push(redirectUrl);
      }
    } catch (err) {
      dispatch(requestEnd());
      console.log(err);
      dispatch(otpLoginFailed('Login Failed.'));
    } finally {
      history.push('/home');
      modalCloseHandler();
    }
  };

  const getSapToken = async (token: string) => {
    try {
      const response = await SVLS_API.get(
        `/account/v2/accounts/${JSON.parse(window.atob(token.split('.')[1])).aid
        }/sap-token`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (response.status == 200) {
        sessionStorage.setItem('sap_token', response.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (redirectUrl) {
      otpLogin();
    }
  }, []);

  useEffect(() => {
    if (loggedIn) {
      dispatch(fetchBalance());
    }
  }, [dispatch, loggedIn]);
};

export default useOtpLogin;
